<!-- Global Hero Section -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg'); background-position: center 60%;">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <h1 class="hero-title-global">Join Our Community</h1>
    <p class="lead"
      style="color: rgba(255,255,255,0.9); border: none; background: none; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">
      Volunteer with Bayou Lacombe Museum and help preserve our rich local history and culture.
    </p>
  </div>
</header>

<main class="container volunteer-container">
  <div class="volunteer-grid">
    <!-- Informational Card -->
    <div class="info-card">
      <span class="badge">Make a Difference</span>
      <h2>Why Volunteer?</h2>
      <p>
        The Bayou Lacombe Museum is powered by passionate community members who bring our exhibits, educational tours, and gardens to life. Whether you have two hours a month or a whole afternoon a week, your time helps preserve 300+ years of Northshore Louisiana heritage.
      </p>

      <div class="roles-list">
        <div class="role-item">
          <mat-icon class="role-icon">museum</mat-icon>
          <div>
            <h4>Docent & Gallery Host</h4>
            <p>Welcome weekend visitors, answer questions about the 1912 schoolhouse, and share Lacombe’s stories.</p>
          </div>
        </div>

        <div class="role-item">
          <mat-icon class="role-icon">park</mat-icon>
          <div>
            <h4>Gardens & Grounds</h4>
            <p>Help tend our native Three Sisters and Medicine Wheel Gardens, keeping native flora thriving.</p>
          </div>
        </div>

        <div class="role-item">
          <mat-icon class="role-icon">celebration</mat-icon>
          <div>
            <h4>Special Events</h4>
            <p>Support lectures, community markets, historical reenactments, and holiday celebrations.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Form Card -->
    <div class="form-card">
      <div [hidden]="success">
        <h3>Sign Up to Volunteer</h3>
        <p class="form-intro">Fill out the form below and our team will get in touch with you.</p>

        <form [formGroup]="volunteerForm" (ngSubmit)="onSubmit()" class="styled-volunteer-form">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Your Full Name</mat-label>
            <input matInput formControlName="name" autocomplete="name" placeholder="e.g. Jane Doe" required>
            <mat-icon matPrefix>person</mat-icon>
            <mat-error *ngIf="name.errors && (name.dirty || name.touched)">
              Name is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email Address</mat-label>
            <input matInput formControlName="email" autocomplete="email" placeholder="jane@example.com" required>
            <mat-icon matPrefix>email</mat-icon>
            <mat-error *ngIf="email.errors && (email.dirty || email.touched)">
              Please enter a valid email
            </mat-error>
          </mat-form-field>

          <div class="options-group">
            <label class="options-label">I'm most interested in helping with:</label>
            <mat-radio-group formControlName="volunteer" class="custom-radio-group">
              <mat-radio-button value="Daily" color="primary">Daily Operations & Greeting</mat-radio-button>
              <mat-radio-button value="Events" color="primary">Special Events & Programs</mat-radio-button>
              <mat-radio-button value="Fundraising" color="primary">Gardens & Fundraising</mat-radio-button>
            </mat-radio-group>
          </div>

          <button mat-flat-button color="primary" class="submit-btn" [disabled]="volunteerForm.invalid || loading" type="submit">
            <mat-icon>volunteer_activism</mat-icon>
            {{ loading ? 'Submitting...' : 'Sign Me Up' }}
          </button>
        </form>
      </div>

      <div class="success-message" *ngIf="success">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h3>Thank You for Volunteering!</h3>
        <p>Your volunteer application for <strong>{{ submittedData.role }}</strong> has been recorded.</p>
        
        <div class="email-action-box">
          <p class="email-action-desc">
            Want to reach out right away? Click below to send a prefilled confirmation email to the volunteer coordinator:
          </p>
          <a [href]="mailtoLink" class="email-confirm-btn">
            <mat-icon>email</mat-icon>
            <span>Send Direct Volunteer Note</span>
          </a>
        </div>

        <div style="margin-top: 1.5rem;">
          <button mat-stroked-button color="primary" routerLink="/">Return Home</button>
        </div>
      </div>
    </div>
  </div>
</main>   
      